export interface TsAppVersion {
    version: string;
    name: string;
    description?: string;
    versionLong?: string;
    versionDate: string;
    gitCommitHash?: string;
    gitCommitDate?: string;
    gitTag?: string;
};

export const versions: TsAppVersion = {
    version: '2.8.4',
    name: 'fpar',
    versionDate: '2026-11-03T16:45:03.755Z',
};
export default versions;
